// Convert font-size to fontSize
export default function kebabCaseToCamel(kebabStr: string) {
  return kebabStr.replace(/-(.)/g, (match, p1, offset, string, groups) => {
    return p1.toUpperCase();
  });
}
